import { EIIState } from 'app/shared/enums/international-invoice.enums';
import { EDeclarationPaymentStatus } from '@models';

export const ZEBRA_ALLOWED_PRINT_STATES: EIIState[] = [
  EIIState.VERIFIED,
];

export const DeclarationPaymentStatusTranslations: Record<EDeclarationPaymentStatus, string> = {
  NeedPay: 'Очікує сплати',
  PaidCash: 'Сплачено',
};
